var angular = require('angular');
var _module = require('./module');
var config = require('config');
var $ = require('jquery');

require('../services/raygun');
require('angular-ui-router');
require('angular-local-storage');
require('./home');
require('./search-results');
require('./view-listing');
require('./view-private-listing');
require('./account-settings');
require('./account-settings/edit-profile');
require('./account-settings/favorite-listings');
require('./account-settings/notification-settings');
require('./account-verification-success');
require('./device-auth-success');
require('./listing-activity-feed');
require('./listing-activity-feed/activity-feed');
require('./invite-reject-accept');
require('./brandednav-staticpage');
require('./widgets');
require('./widgets/search-box-video');
require('./tap-test');
require('../services/user');
require('../services/fullscreen-loading');
require('../services/affiliate-modal');
require('../services/analytics');
require('../services/activity-feed');
require('../services/keep-affiliate-in-url');
require('./invite-search-filter');

_module.requires.push('ui.router', 'LocalStorageModule');

_module.run([
    '$rootScope',
    '$window',

    function applicationRun($rootScope, $window) {
        $rootScope.$on('$stateChangeSuccess', function (_a, _b, _c, os) {
            // Dont do it for children
            // if(!$state.includes(os) || $state.is(os)) {
            //     console.log('Scroll to the top!');
            //     window.scrollTo(0, 0);
            // }

            // Do it for all
            window.scrollTo(0, 0);
        });

        // Detect mobile safari
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

        if (iOSSafari) {
            $('body').addClass('safari-mobile');
        }
    }
]);

_module.config([
    '$logProvider',
    '$locationProvider',
    '$stateProvider',
    '$urlRouterProvider',
    '$mdThemingProvider',
    'uiGmapGoogleMapApiProvider',
    '$activityFeedProvider',
    'keepAffiliateInUrlProvider',

    function configProvider($logProvider, $locationProvider, $stateProvider, $urlRouterProvider, $mdThemingProvider, uiGmapGoogleMapApiProvider, $activityFeedProvider, keepAffiliateInUrlProvider) {
        $logProvider.debugEnabled(config.allowDebugLogs);
        $locationProvider.html5Mode(true);

        uiGmapGoogleMapApiProvider.configure({
            key: config.google.apiKey,
            v: '3.22',
            libraries: 'visualization'
        });

        $activityFeedProvider.setBaseUrl(config.listreportsUrl);

        keepAffiliateInUrlProvider.addRoutesToIgnore('logout', 'clearstorage', 'accountverificationsuccess', 'deviceauthsuccess', 'inviterejectaccept', 'affiliatecode', 'invitesearchfilter');


        /*
        Resolve Functions
        */

        // Resolve if user has an affiliateId
        var affiliateModal;
        function hasAffiliateCode($user, $affiliateModal) {
            if(!$user.affiliateId && !affiliateModal) {
                affiliateModal = $affiliateModal();
            }

            return true;
        }


        /*
        ROUTES
        */

        // Clear All Local Storage
        $stateProvider.state(
            'clearstorage',
            {
                url: '/cmlsp',
                controller: [
                    '$log',
                    'localStorageService',

                    function ($log, localStorageService) {
                        localStorageService.clearAll();
                        $log.debug('Cleared Users Local Storage');

                        window.location = '/';
                    }
                ]
            }
        );

        // Logout
        $stateProvider.state(
            'logout',
            {
                url: '/logout',
                controller: [
                    '$log',
                    '$user',

                    function logoutCtrl($log, $user) {
                        try {
                            window.mixpanel.cookie.clear();
                        } catch (err) {
                            $log.error('Error clearing mixpanel cookie', err);
                        }

                        $user.logout();
                    }
                ]
            }
        );

        /**
         * Home
         * @query
         * @param {String} [affiliate]
         * @param {String} [ref]
         * @param {Boolean} [psffr=false] - Prevent Search Filter Found Redirect
         */
        $stateProvider.state(
            'homepage',
            {
                url: '/?affiliate&ref&psffr',
                template: '<homepage></homepage>',
                data: {
                    layout: {
                        hideHeader: true
                    }
                },
                resolve: {
                    affiliate: ['$user', '$affiliateModal', hasAffiliateCode]
                },
                params: {
                    preventSearchFilterRedirect: false
                }
            }
        );

        // Search Results
        $stateProvider.state(
            'search',
            {
                url: '/search?q&affiliate',
                template: '<search-results></search-results>',
                data: {
                    layout: {
                        showHeaderBg: true,
                        headerClass: 'search-results-header',
                        footerClass: 'hide'
                    }
                },
                resolve: {
                    affiliate: ['$user', '$affiliateModal', hasAffiliateCode]
                },
                reloadOnSearch: false,
                params: {
                    reloadData: false,
                    reloadDataInBackground: false,
                    bypassCache: false
                }
            }
        );

        // View Listing
        $stateProvider.state(
            'viewlisting',
            {
                url: '/listings/:listingId/:address?filter&a&affiliate&ref&openhouse',
                template: '<viewlisting></viewlisting>',
                data: {
                    layout: {
                        showHeaderBg: true,
                        headerClass: 'view-listing-header'
                    }
                },
                resolve: {
                    affiliate: ['$user', '$affiliateModal', hasAffiliateCode]
                },
                reloadOnSearch: false
            }
        );

        // View Private Listing
        $stateProvider.state(
            'viewprivatelisting',
            {
                url: '/private-listings/:privateListingId/:address',
                template: '<view-private-listing></view-private-listing>',
                data: {
                    layout: {
                        hideHeader: true
                    }
                },
                reloadOnSearch: false
            }
        );

        // Account Verification Success
        $stateProvider.state(
            'accountverificationsuccess',
            {
                url: '/accounts/verifications/:code/:type/success?redirect',
                template: '<account-verification-success></account-verification-success>',
                data: {
                    layout: {
                        showHeaderBg: true
                    }
                }
            }
        );

        // Account Verification Success
        $stateProvider.state(
            'deviceauthsuccess',
            {
                url: '/accounts/devices/:code/success',
                template: '<device-auth-success></device-auth-success>',
                data: {
                    layout: {
                        showHeaderBg: true
                    }
                }
            }
        );

        // Invite Create Search Filter Form
        $stateProvider.state(
            'invitesearchfilter',
            {
                url: '/accounts/invites/:encodedUserId/searchfhilters/new',
                template: '<invite-search-filter ui-view></invite-search-filter>',
                data: {
                    layout: {
                        showHeaderBg: true
                    }
                }
            }
        );

        $stateProvider.state(
            'invitesearchfilter.success',
            {
                url: '/success',
                template: '<invite-search-filter-success></invite-search-filter-success>',
                data: {
                    layout: {
                        showHeaderBg: true
                    }
                }
            }
        );

        // Account Verification Success
        $stateProvider.state(
            'inviterejectaccept',
            {
                url: '/accounts/invites/:type?d',
                template: '<invite-reject-accept></invite-reject-accept>',
                data: {
                    layout: {
                        showHeaderBg: true
                    }
                }
            }
        );

        // Listing Activity Feed
        $stateProvider.state(
            'feed',
            {
                url: '/feed?a&showType',
                template: '<listing-activity-feed></listing-activity-feed>',
                resolve: {
                    affiliate: ['$user', '$affiliateModal', hasAffiliateCode]
                },
                data: {
                    layout: {
                        showHeaderBg: true,
                        headerClass: 'listing-activity-feed-header'
                    }
                }
            }
        );

        // Account Settings Base State
        $stateProvider.state(
            'accountsettings',
            {
                url: '/account',
                abstract: true,
                template: '<account-settings></account-settings>',
                data: {
                    layout: {
                        showHeaderBg: true,
                        headerClass: 'account-settings'
                    }
                },
                resolve: {
                    affiliate: ['$user', '$affiliateModal', hasAffiliateCode]
                }
            }
        );

        // Account Settings - Edit Profile
        $stateProvider.state(
            'accountsettings.editprofile',
            {
                url: '/editprofile',
                template: '<edit-profile></edit-profile>'
            }
        );

        // Account Settings - Favorite Listings
        $stateProvider.state(
            'accountsettings.favorites',
            {
                url: '/favorites',
                template: '<favorite-listings></favorite-listings>'
            }
        );

        // Account Settings - Notification Settings
        $stateProvider.state(
            'accountsettings.notifications',
            {
                url: '/notifications',
                template: '<notification-settings></notification-settings>'
            }
        );

        // Account Settings - Mobile Menu
        $stateProvider.state(
            'accountsettings.menu',
            {
                url: '/menu',
                template: ''
            }
        );

        $urlRouterProvider.when('/account', '/account/editprofile');
        $urlRouterProvider.when('/account/', '/account/editprofile');


        // Static Pages
        $stateProvider.state(
            'branded-nav-pages',
            {
                url: '^/pages/:pageId/:slug',
                template: '<brandednav-staticpage></brandednav-staticpage>',
                data: {
                    layout: {
                        hideHeader: true
                    }
                }
            }
        );


        // Widgets

        // Widget Container Base State
        $stateProvider.state(
            'widget',
            {
                url: '/widget',
                abstract: true,
                template: '<widget-container></widget-container>',
                data: {
                    layout: {
                        showHeaderBg: false,
                        headerClass: 'hide',
                        footerClass: 'hide'
                    }
                }
            }
        );

        // Search Box Video State
        $stateProvider.state(
            'widget.searchboxvideo',
            {
                url: '/searchboxvideo?affiliate&theme&hideVideo&responsive',
                template: '<search-box-video></search-box-video>'
            }
        );

        // Tap Test Route
        // $stateProvider.state(
        //     'tap-test',
        //     {
        //         url: '^/test/tap',
        //         template: '<tap-test></tap-test>',
        //         data: {
        //             layout: {
        //                 hideHeader: true,
        //                 footerClass: 'hide'
        //             }
        //         }
        //     }
        // );

        // Affiliate Code
        $stateProvider.state(
            'affiliatecode',
            {
                url: '/:affiliateCode?ref',
                controller: [
                    '$log',
                    '$http',
                    '$location',
                    '$state',
                    '$stateParams',
                    '$user',
                    '$fsloading',
                    '$analytics',
                    '$activityFeed',
                    '$timeout',

                    function affiliatecodeCtrl($log, $http, $location, $state, $stateParams, $user, $fsloading, $analytics, $activityFeed, $timeout) {
                        if($stateParams.affiliateCode) {
                            $fsloading.show();

                            $analytics.eventTrack('Affiliate Link Click');

                            $timeout(function () {
                                $user.setAffiliateId($stateParams.affiliateCode.toLowerCase())
                                .finally(function () {
                                    $fsloading.hide();
                                    $state.go('homepage', { ref: $location.search().ref });
                                });
                            }, (isIE() ? 700 : 0));
                        } else {
                            $state.go('homepage', { ref: $location.search().ref });
                        }

                        function isIE() {
                            var ua = window.navigator.userAgent;
                            return ~ua.indexOf('MSIE ') || ~ua.indexOf('Trident/');
                        }
                    }
                ]
            }
        );


        /* NG MATERIAL THEME PALETTE */
        var lrPrimary = {
            '50': '#9adfd9',
            '100': '#87d9d1',
            '200': '#74d3ca',
            '300': '#60cdc3',
            '400': '#4dc7bb',
            '500': '#3cbeb2',
            '600': '#36aba0',
            '700': '#30978e',
            '800': '#2a847b',
            '900': '#247069',
            'A100': '#aee5e0',
            'A200': '#c1ebe8',
            'A400': '#d4f2ef',
            'A700': '#1d5d57'
        };
        $mdThemingProvider.definePalette('lrPrimary', lrPrimary);

        var lrAccent = {
            '50': '#a5a5c4',
            '100': '#9596ba',
            '200': '#8687b0',
            '300': '#7677a6',
            '400': '#67689c',
            '500': '#5c5d8d',
            '600': '#52537e',
            '700': '#48496e',
            '800': '#3e3e5f',
            '900': '#34344f',
            'A100': '#b4b4ce',
            'A200': '#c3c4d8',
            'A400': '#d3d3e2',
            'A700': '#2a2a40'
        };
        $mdThemingProvider.definePalette('lrAccent', lrAccent);

        var lrWarn = {
            '50': '#f08d90',
            '100': '#ed767b',
            '200': '#ea6065',
            '300': '#e7494f',
            '400': '#e43339',
            '500': '#df1e25',
            '600': '#c81b21',
            '700': '#b2181e',
            '800': '#9c151a',
            '900': '#851216',
            'A100': '#f3a3a6',
            'A200': '#f6babc',
            'A400': '#f9d0d2',
            'A700': '#6f0f12'
        };
        $mdThemingProvider.definePalette('lrWarn', lrWarn);

        var lrBackground = {
            '50': '#ffffff',
            '100': '#ffffff',
            '200': '#ffffff',
            '300': '#ffffff',
            '400': '#ffffff',
            '500': '#fff',
            '600': '#f2f2f2',
            '700': '#e6e6e6',
            '800': '#d9d9d9',
            '900': '#cccccc',
            'A100': '#ffffff',
            'A200': '#ffffff',
            'A400': '#ffffff',
            'A700': '#bfbfbf'
        };
        $mdThemingProvider.definePalette('lrBackground', lrBackground);

        $mdThemingProvider
            .theme('default')
            .primaryPalette('lrPrimary')
            .accentPalette('lrAccent')
            .warnPalette('lrWarn')
            .backgroundPalette('lrBackground');
    }
]);
